module.exports = __webpack_public_path__ + "static/media/C2.4dd46dba.png";